import { render, staticRenderFns } from "./StaffEditComponent.vue?vue&type=template&id=751281d7"
import script from "./StaffEditComponent.vue?vue&type=script&lang=js"
export * from "./StaffEditComponent.vue?vue&type=script&lang=js"
import style0 from "./StaffEditComponent.vue?vue&type=style&index=0&id=751281d7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports